<template>
    <!-- <div>{{ transactions[0].site_name }}</div> -->
    <div class="c-transaction-list" v-for="transaction in transactions" :key="transaction.uuid">
        <div class="c-transaction-list__item">
            <div class="c-transaction__status">
                <p class="date">{{ transaction.update_timestamp }}</p>
                <ul class="c-transaction__label">
                    <li class="type"><span>{{ transaction.charge_type }}</span></li>
                    <li class="status" :class="getPaymentStatusClass(transaction.payment_status)"><span>{{ constants.PAYMENT_STATUS[transaction.payment_status] }}</span></li>
                </ul>
            </div>
            <p class="c-transaction__product"><span>{{ transaction.site_name }}</span></p>
            <p class="c-transaction__uuid">{{ $t("LABEL_PAYMENT_ID") }}: {{ transaction.payment_id }}</p>
        </div>
        <div class="c-transaction-list__amount"><span class="num" @copy="handleCopy($event, transaction)">{{ getFormattedAmount(transaction).display }}</span>円</div>
    </div>
</template>

<script setup>
import CONSTS from "@/data/constants";
import { PAYMENT_STATUS_CLASS } from "@/data/constants";
import { computed } from 'vue'
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const constants = computed(() => {
    return CONSTS[locale.value];
});
const props = defineProps(['transactions'])

function getPaymentStatusClass(status) {
    return PAYMENT_STATUS_CLASS[Number(status)] ?? "status--processing";
}

function getFormattedAmount(transaction) {
    const amount = transaction.base_price_amount + transaction.commission + transaction.transportation_fee + transaction.system_fee;
    return {
        display: amount.toLocaleString('ja-JP'),
        raw: amount
    };
}

function handleCopy(e, transaction) {
    e.clipboardData.setData('text/plain', String(getFormattedAmount(transaction).raw));
    e.preventDefault();
}
</script>